(function () {
  function updateDots(section, activeIndex) {
    section.querySelectorAll('[data-am-featured-dot]').forEach(function (dot, index) {
      dot.classList.toggle('is-active', index === activeIndex);
    });
  }

  function initCarousel(section) {
    var scroller = section.querySelector('[data-am-featured-scroller]');
    if (!scroller) return;

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-am-card]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-am-featured-dot]'));

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = Number(dot.getAttribute('data-am-featured-dot'));
        if (!cards[index]) return;
        scroller.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
        updateDots(section, index);
      });
    });

    var ticking = false;
    scroller.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var activeIndex = 0;
        var closestDistance = Infinity;

        cards.forEach(function (card, index) {
          var distance = Math.abs(card.offsetLeft - scroller.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });

        updateDots(section, activeIndex);
        ticking = false;
      });
    });
  }

  var SWATCH_MOBILE_QUERY = '(max-width: 740px)';

  function isMobileSwatchRow() {
    return window.matchMedia && window.matchMedia(SWATCH_MOBILE_QUERY).matches;
  }

  function getSwatchParts(carousel) {
    var viewport = carousel.querySelector('[data-am-card-swatch-viewport]');
    var track = carousel.querySelector('[data-am-card-swatch-track]') || carousel.querySelector('[data-am-card-swatch-list]');

    return {
      carousel: carousel,
      viewport: viewport || track,
      track: track,
      prev: carousel.querySelector('[data-am-card-swatch-nav="prev"]'),
      next: carousel.querySelector('[data-am-card-swatch-nav="next"]'),
      swatches: track ? Array.prototype.slice.call(track.querySelectorAll('[data-am-card-swatch]')) : []
    };
  }

  function getNumber(value, fallback) {
    var number = parseFloat(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function getSwatchMetrics(parts) {
    var styles = window.getComputedStyle(parts.track);
    var gap = getNumber(styles.columnGap || styles.gap, 8);
    var itemWidth = parts.swatches[0] ? parts.swatches[0].offsetWidth : 24;
    var itemStep = itemWidth + gap;
    var viewportWidth = parts.viewport ? parts.viewport.clientWidth : 0;
    var totalWidth = parts.swatches.length * itemStep - gap;
    var pageSize = Math.max(1, Math.floor((viewportWidth + gap) / itemStep));

    return {
      gap: gap,
      itemStep: itemStep,
      pageSize: pageSize,
      totalWidth: Math.max(totalWidth, parts.track.scrollWidth || 0),
      viewportWidth: viewportWidth
    };
  }

  function getSwatchPageStart(carousel) {
    return Number(carousel.getAttribute('data-am-card-swatch-page-start') || 0) || 0;
  }

  function setSwatchPageStart(carousel, start) {
    carousel.setAttribute('data-am-card-swatch-page-start', String(Math.max(0, start)));
  }

  function getLastSwatchPageStart(total, pageSize) {
    if (total <= pageSize) return 0;
    return Math.floor((total - 1) / pageSize) * pageSize;
  }

  function setSwatchTrackPosition(parts, start, metrics) {
    if (!parts.track || !parts.track.style) return;
    parts.track.style.transform = 'translate3d(' + (-start * metrics.itemStep) + 'px, 0, 0)';
  }

  function updateSwatchCarousel(carousel) {
    var parts = getSwatchParts(carousel);
    if (!parts.track || !parts.swatches.length) return;

    var metrics = getSwatchMetrics(parts);
    var mobile = isMobileSwatchRow();
    var isPaged = !mobile && parts.swatches.length > metrics.pageSize;

    carousel.classList.toggle('is-scrollable', mobile && parts.swatches.length > metrics.pageSize);
    carousel.classList.toggle('is-paged', isPaged);

    if (mobile || !isPaged) {
      setSwatchPageStart(carousel, 0);
      setSwatchTrackPosition(parts, 0, metrics);

      [parts.prev, parts.next].forEach(function (nav) {
        if (nav) nav.hidden = true;
      });
      return;
    }

    var lastStart = getLastSwatchPageStart(parts.swatches.length, metrics.pageSize);
    var start = Math.min(getSwatchPageStart(carousel), lastStart);
    setSwatchPageStart(carousel, start);
    setSwatchTrackPosition(parts, start, metrics);

    if (parts.prev) {
      parts.prev.hidden = false;
      parts.prev.disabled = start <= 0;
    }

    if (parts.next) {
      parts.next.hidden = false;
      parts.next.disabled = start >= lastStart;
    }
  }

  function scrollSwatchCarousel(nav) {
    var carousel = nav.closest('[data-am-card-swatch-carousel]') || nav.closest('[data-am-card-swatch-row]');
    if (!carousel) return;

    var parts = getSwatchParts(carousel);
    if (!parts.track || !parts.swatches.length) return;

    var metrics = getSwatchMetrics(parts);
    var lastStart = getLastSwatchPageStart(parts.swatches.length, metrics.pageSize);
    var currentStart = getSwatchPageStart(carousel);
    var direction = nav.getAttribute('data-am-card-swatch-nav') === 'prev' ? -1 : 1;
    var nextStart = direction > 0
      ? Math.min(lastStart, currentStart + metrics.pageSize)
      : Math.max(0, currentStart - metrics.pageSize);

    setSwatchPageStart(carousel, nextStart);
    updateSwatchCarousel(carousel);
  }

  function initSwatchRows(card) {
    card.querySelectorAll('[data-am-card-swatch-carousel], [data-am-card-swatch-row]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-am-card-swatch-track]') || carousel.querySelector('[data-am-card-swatch-list]');
      if (!track) return;

      if (carousel.getAttribute('data-am-card-swatch-row-initialized') !== 'true') {
        carousel.setAttribute('data-am-card-swatch-row-initialized', 'true');

        window.addEventListener('resize', function () {
          updateSwatchCarousel(carousel);
        }, { passive: true });
      }

      window.requestAnimationFrame(function () {
        updateSwatchCarousel(carousel);
      });
    });
  }

  function initCards(section) {
    section.querySelectorAll('[data-am-card]').forEach(function (card) {
      if (card.getAttribute('data-am-card-initialized') === 'true') return;
      card.setAttribute('data-am-card-initialized', 'true');

      card.addEventListener('click', function (event) {
        var swatchNav = event.target.closest('[data-am-card-swatch-nav]');
        if (swatchNav && card.contains(swatchNav)) {
          event.preventDefault();
          scrollSwatchCarousel(swatchNav);
          return;
        }

        var selectedSwatch = event.target.closest('[data-am-card-swatch]');
        if (!selectedSwatch || !card.contains(selectedSwatch)) return;

        event.preventDefault();
        selectSwatch(card, selectedSwatch);
      });

      initSwatchRows(card);
    });
  }

  function selectSwatch(card, selectedSwatch) {
    var variantId = selectedSwatch.getAttribute('data-variant-id');
    if (!variantId) return;

    var variantInput = card.querySelector('[data-am-card-variant-input]');
    var image = card.querySelector('[data-am-card-image]');
    var price = card.querySelector('[data-am-card-price]');
    var compare = card.querySelector('[data-am-card-compare]');
    var saleBadge = card.querySelector('[data-am-sale-badge]');
    var button = card.querySelector('.am-card__button');
    var imageUrl = selectedSwatch.getAttribute('data-image');
    var priceHtml = selectedSwatch.getAttribute('data-price-html');
    var compareHtml = selectedSwatch.getAttribute('data-compare-price-html');
    var onSale = selectedSwatch.getAttribute('data-on-sale') === 'true';
    var available = selectedSwatch.getAttribute('data-available') !== 'false';

    if (variantInput) variantInput.value = variantId;
    if (image && imageUrl) {
      image.setAttribute('src', imageUrl);
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    }
    if (price && priceHtml) price.innerHTML = priceHtml;
    if (button) button.disabled = !available;

    if (compare) {
      compare.innerHTML = onSale && compareHtml ? compareHtml : '';
      compare.hidden = !onSale;
    }

    if (saleBadge) saleBadge.hidden = !onSale;

    card.querySelectorAll('[data-am-card-swatch]').forEach(function (item) {
      var isActive = item === selectedSwatch;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    updateProductLinks(card, variantId);
  }

  function updateProductLinks(card, variantId) {
    if (!variantId) return;

    card.querySelectorAll('[data-am-product-link]').forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        url.searchParams.set('variant', variantId);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (error) {
        // Keep the original href if the browser cannot parse it.
      }
    });
  }

  function initCartDrawerFallback() {
    if (window.amFigmaCartDrawerFallbackBound) return;
    window.amFigmaCartDrawerFallbackBound = true;

    document.addEventListener('variant:added', function (event) {
      var form = event.target && event.target.closest && event.target.closest('[data-am-card-form]');
      if (!form || !document.querySelector('cart-drawer')) return;

      window.setTimeout(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            openMiniCart: true
          }
        }));
      }, 0);
    });
  }

  function initSection(section) {
    if (section.dataset.amFeaturedInitialized === 'true') return;
    section.dataset.amFeaturedInitialized = 'true';

    initCarousel(section);
    initCards(section);
  }

  function init() {
    initCartDrawerFallback();

    document.querySelectorAll('[data-am-figma-featured-products], [data-am-ymm-filtered-collections]').forEach(function (section) {
      initSection(section);
    });
  }

  window.AM_FIGMA_PRODUCT_CARDS = window.AM_FIGMA_PRODUCT_CARDS || {};
  window.AM_FIGMA_PRODUCT_CARDS.initCards = initCards;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;

    event.target.querySelectorAll('[data-am-figma-featured-products], [data-am-ymm-filtered-collections]').forEach(function (section) {
      initSection(section);
    });
  });
})();
